module.exports = __webpack_public_path__ + "img/08_20-09-09_Life-Insurance-Guide_Products_Final-Expense-Icon.ba51acc7.svg";